const en = {
  language_zh: 'Chinese',
  language_en: 'English',

  login_systemHeader:
    'Shanghai Xingchi Light Box Billboard Intelligent Control System',
  login_header: 'System Login',
  login_userAccount: 'user name',
  login_userAccountMsg: 'Please input user name',
  login_password: 'password',
  login_passwordMsg: 'Please input password',
  login_code: 'Verification Code',
  login_codeMsg: 'Please input Verification Code',
  login_changeImg: 'Click to change the verification code',
  login_rememberpwd: 'Remember account password',
  login_submit: 'Sign in',
  login_reset: 'Reset',
  login_Footer1: 'Recommended',
  login_Footer2: 'Google, Firefox or Internet Explorer 11 or above',
  login_Footer3:
    '。 If you use 360, QQ, Cheetah and other browsers, please select',
  login_Footer4: 'Extreme speed mode.',
}
export default en
